
import { Injectable } from '@angular/core';
import { AbstractFormActionHandler } from '../abstract-form-action-handler';
import { FormService } from '../../../form.service';
import { HandleCountryPhoneActionHandler } from './handle-country-phone-action-handler';

@Injectable()
export class HandleCountrySecondaryMobileActionHandler extends HandleCountryPhoneActionHandler {

    protected getPhoneCountryCodeDatamodelField(): string {
        return 'secondaryMobileCountryCode';
    }

    protected getPhoneAreaCodeDatamodelField(): string {
        return 'secondaryMobileAreaCode';
    }

    protected getPhoneNumberDatamodelField(): string {
        return 'secondaryMobileNumber';
    }
}
